import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from './index';
import CastleQuestionsSearch from './components/castleQuestionsSearch/main';
import CastleReadingSets from './pages/castleReadingSets/pages/castleReadingSets';
import MathSkills from './components/mathSkills/mathSkills';
import DBQSets from './components/dbqSets/dbqSets';
import { AssignmentProvider } from '../assignments/context';
import MathSkillQuestions from './components/mathSkills/MathSkillQuestions';
import { DataProvider } from '../assignments/DataContext';

const Main = () => {
  return (
    <div>
      <AssignmentProvider>
        <Routes>
          <Route path="/" element={<DataProvider><Index /></DataProvider>}>
            <Route index element={<Navigate to="assignment/castle_questions" />} />
            <Route path=":from?/:assignmentId?/castle_questions/*" element={<CastleQuestionsSearch />} />
            <Route path=":from?/:assignmentId?/castle_reading_sets" element={<CastleReadingSets />} />
            <Route path=":from?/:assignmentId?/math_skills" element={<MathSkills />} />
            <Route path=":from?/:assignmentId?/math_skills/math_skills_questions" element={<MathSkillQuestions />} />
            <Route path=":from?/:assignmentId?/dbqSets" element={<DBQSets />} />
          </Route>
        </Routes>
      </AssignmentProvider>
    </div>
  );
};

export default Main;